// export const maximumUsers = {
//     active: false,
//     maxUsers: 28
// };
// export const excelFile = true
// export const firstLevel = false
// export const roleNameArabic = true
// export const controlFieldsAmAndPm = true
// export const managementHierarchyRegions = true
// export const extraField = true
// export const separatingSpecialtiesFromTeams = true
// export const linkingMaterialsToSpecializations = true
// export const hideSomeStatistics = false
// export const showOutgoingAndRemainingItemsStat = true
// export const showCountEmployeeNumberStat = true
// export const addFilterAccountEmployee = true
// export const showPlannedVisitStatistics = true
// export const addPrice = true
// export const hideTabsCustomer = true
// export const newColumnForWorkloadStatistics = true
// export const doctorFilterInCustomerInterface = true
// export const medicalSystem = true
// export const addLocationByMap = true
// export const weeklyPlan = true
// export const useTheUpperAndLowerLimitsForSalesRep = true
// export const financialTargetValue = true
// export const enableFreeDistributionWithPrice = true
// export const pharmacistInfoShow = true
// export const similarityPercentage = true
// export const includeAddressWithCustomers = true
// export const showLoyalty = true
// export const activateNotification = true
// export const managementPriceType = true
// export const isDisabledFriday = true
// export const lineManagerInAdd = true
// export const enablePricesTypes = true
// export const enableDiscount = true
// export const isIntNumberRule = true
// export const materialStockByCity = true
// export const cancelAdministrativeDayLeave = true
// export const enableCustomerType = true
// export const enableVacations = false
// export const isVisitCount = false
// export const enableRateVisitDependingNumberCustomer = true 
// export const enableAddingFromRep = true

/* Ibn-alhaytham */
// export const maximumUsers = {
//     active: false,
//     maxUsers: 28
// };
// export const excelFile = false
// export const firstLevel = false
// export const roleNameArabic = false
// export const controlFieldsAmAndPm = false
// export const managementHierarchyRegions = false
// export const extraField = false
// export const separatingSpecialtiesFromTeams = false
// export const linkingMaterialsToSpecializations = false
// export const hideSomeStatistics = true
// export const showOutgoingAndRemainingItemsStat = false
// export const showCountEmployeeNumberStat = true
// export const addFilterAccountEmployee = false
// export const showPlannedVisitStatistics = true
// export const addPrice = false
// export const hideTabsCustomer = false
// export const newColumnForWorkloadStatistics = false
// export const doctorFilterInCustomerInterface = false
// export const medicalSystem = true
// export const addLocationByMap = false
// export const weeklyPlan = false
// export const useTheUpperAndLowerLimitsForSalesRep = false
// export const financialTargetValue = false
// export const enableFreeDistributionWithPrice = false
// export const pharmacistInfoShow = false
// export const similarityPercentage = false
// export const includeAddressWithCustomers = false
// export const showLoyalty = false
// export const activateNotification = false
// export const managementPriceType = false
// export const isDisabledFriday = true
// export const lineManagerInAdd = false
// export const enablePricesTypes = false
// export const enableDiscount = false
// export const isIntNumberRule = true
// export const materialStockByCity = false
// export const cancelAdministrativeDayLeave = true
// export const enableCustomerType = false
// export const enableVacations = false
// export const isVisitCount = false
// export const enableRateVisitDependingNumberCustomer = false
// export const enableAddingFromRep = false

/* AlKhalil */
// export const maximumUsers = {
//     active: false,
//     maxUsers: 28
// };
// export const excelFile = false
// export const firstLevel = false
// export const roleNameArabic = false
// export const controlFieldsAmAndPm = false
// export const managementHierarchyRegions = false
// export const extraField = false
// export const separatingSpecialtiesFromTeams = false
// export const linkingMaterialsToSpecializations = false
// export const hideSomeStatistics = true
// export const showOutgoingAndRemainingItemsStat = false
// export const showCountEmployeeNumberStat = true
// export const addFilterAccountEmployee = false
// export const showPlannedVisitStatistics = true
// export const addPrice = false
// export const hideTabsCustomer = false
// export const newColumnForWorkloadStatistics = false
// export const doctorFilterInCustomerInterface = false
// export const medicalSystem = true
// export const addLocationByMap = false
// export const weeklyPlan = false
// export const useTheUpperAndLowerLimitsForSalesRep = false
// export const financialTargetValue = false
// export const enableFreeDistributionWithPrice = false
// export const pharmacistInfoShow = false
// export const similarityPercentage = false
// export const includeAddressWithCustomers = false
// export const showLoyalty = false
// export const activateNotification = false
// export const managementPriceType = false
// export const isDisabledFriday = false
// export const lineManagerInAdd = false
// export const enablePricesTypes = false
// export const enableDiscount = false
// export const isIntNumberRule = true
// export const materialStockByCity = false
// export const cancelAdministrativeDayLeave = true
// export const enableCustomerType = false
// export const enableVacations = false
// export const isVisitCount = false
// export const enableRateVisitDependingNumberCustomer = true
// export const enableAddingFromRep = true

/* Oubari */
// export const maximumUsers = {
//     active: false,
//     maxUsers: 28
// };
// export const excelFile = false
// export const firstLevel = false
// export const roleNameArabic = false
// export const controlFieldsAmAndPm = false
// export const managementHierarchyRegions = false
// export const extraField = false
// export const separatingSpecialtiesFromTeams = false
// export const linkingMaterialsToSpecializations = false
// export const hideSomeStatistics = true
// export const showOutgoingAndRemainingItemsStat = false
// export const showCountEmployeeNumberStat = true
// export const addFilterAccountEmployee = false
// export const showPlannedVisitStatistics = true
// export const addPrice = false
// export const hideTabsCustomer = false
// export const newColumnForWorkloadStatistics = false
// export const doctorFilterInCustomerInterface = false
// export const medicalSystem = true
// export const addLocationByMap = false
// export const weeklyPlan = false
// export const useTheUpperAndLowerLimitsForSalesRep = false
// export const financialTargetValue = false
// export const enableFreeDistributionWithPrice = false
// export const pharmacistInfoShow = false
// export const similarityPercentage = false
// export const includeAddressWithCustomers = false
// export const showLoyalty = false
// export const activateNotification = false
// export const managementPriceType = false
// export const isDisabledFriday = false
// export const lineManagerInAdd = false
// export const enablePricesTypes = false
// export const enableDiscount = false
// export const isIntNumberRule = true
// export const materialStockByCity = false
// export const cancelAdministrativeDayLeave = true
// export const enableCustomerType = false
// export const enableVacations = false
// export const isVisitCount = false
// export const enableRateVisitDependingNumberCustomer = true
// export const enableAddingFromRep = true

/* Oubari */
// export const maximumUsers = {
//     active: false,
//     maxUsers: 28
// };
// export const excelFile = false
// export const firstLevel = true
// export const roleNameArabic = true
// export const controlFieldsAmAndPm = true
// export const managementHierarchyRegions = true
// export const extraField = true
// export const separatingSpecialtiesFromTeams = true
// export const linkingMaterialsToSpecializations = true
// export const hideSomeStatistics = false
// export const showOutgoingAndRemainingItemsStat = true
// export const showCountEmployeeNumberStat = false
// export const addFilterAccountEmployee = true
// export const showPlannedVisitStatistics = false
// export const addPrice = false
// export const hideTabsCustomer = false
// export const newColumnForWorkloadStatistics = true
// export const doctorFilterInCustomerInterface = true
// export const medicalSystem = true
// export const addLocationByMap = false
// export const weeklyPlan = false
// export const useTheUpperAndLowerLimitsForSalesRep = false
// export const financialTargetValue = false
// export const enableFreeDistributionWithPrice = false
// export const pharmacistInfoShow = false
// export const similarityPercentage = false
// export const includeAddressWithCustomers = false
// export const showLoyalty = true
// export const activateNotification = false
// export const managementPriceType = false
// export const isDisabledFriday = false
// export const lineManagerInAdd = false
// export const enablePricesTypes = false
// export const enableDiscount = false
// export const isIntNumberRule = true
// export const materialStockByCity = false
// export const cancelAdministrativeDayLeave = false
// export const enableCustomerType = false
// export const enableVacations = false
// export const isVisitCount = false
// export const enableRateVisitDependingNumberCustomer = false
// export const enableAddingFromRep = true

/* Mirta Olabi */
// export const maximumUsers = {
//     active: false,
//     maxUsers: 28
// };
// export const excelFile = false
// export const firstLevel = false
// export const roleNameArabic = false
// export const controlFieldsAmAndPm = false
// export const managementHierarchyRegions = false
// export const extraField = false
// export const separatingSpecialtiesFromTeams = false
// export const linkingMaterialsToSpecializations = true
// export const hideSomeStatistics = true
// export const showOutgoingAndRemainingItemsStat = false
// export const showCountEmployeeNumberStat = true
// export const addFilterAccountEmployee = false
// export const showPlannedVisitStatistics = true
// export const addPrice = true
// export const hideTabsCustomer = true
// export const newColumnForWorkloadStatistics = false
// export const doctorFilterInCustomerInterface = false
// export const medicalSystem = false
// export const addLocationByMap = true
// export const weeklyPlan = true
// export const useTheUpperAndLowerLimitsForSalesRep = false
// export const financialTargetValue = true
// export const enableFreeDistributionWithPrice = true
// export const pharmacistInfoShow = true
// export const similarityPercentage = true
// export const includeAddressWithCustomers = true
// export const showLoyalty = true
// export const activateNotification = true
// export const managementPriceType = true
// export const isDisabledFriday = false
// export const lineManagerInAdd = false
// export const enablePricesTypes = true
// export const enableDiscount = true
// export const isIntNumberRule = false
// export const materialStockByCity = true
// export const cancelAdministrativeDayLeave = false
// export const enableCustomerType = true
// export const enableVacations = false
// export const isVisitCount = true
// export const enableRateVisitDependingNumberCustomer = true
// export const enableAddingFromRep = true

/* Barakat */
export const maximumUsers = {
    active: false,
    maxUsers: 28
};
export const excelFile = false
export const firstLevel = false
export const roleNameArabic = false
export const controlFieldsAmAndPm = false
export const managementHierarchyRegions = false
export const extraField = false
export const separatingSpecialtiesFromTeams = false
export const linkingMaterialsToSpecializations = true
export const hideSomeStatistics = true
export const showOutgoingAndRemainingItemsStat = false
export const showCountEmployeeNumberStat = true
export const addFilterAccountEmployee = false
export const showPlannedVisitStatistics = true
export const addPrice = true
export const hideTabsCustomer = true
export const newColumnForWorkloadStatistics = false
export const doctorFilterInCustomerInterface = false
export const medicalSystem = false
export const addLocationByMap = true
export const weeklyPlan = false
export const useTheUpperAndLowerLimitsForSalesRep = false
export const financialTargetValue = true
export const enableFreeDistributionWithPrice = true
export const pharmacistInfoShow = true
export const similarityPercentage = true
export const includeAddressWithCustomers = true
export const showLoyalty = true
export const activateNotification = true
export const managementPriceType = true
export const isDisabledFriday = false
export const lineManagerInAdd = false
export const enablePricesTypes = true
export const enableDiscount = true
export const isIntNumberRule = false
export const materialStockByCity = true
export const cancelAdministrativeDayLeave = false
export const enableCustomerType = true
export const enableVacations = false
export const isVisitCount = true
export const enableRateVisitDependingNumberCustomer = true
export const enableAddingFromRep = true
